import { TableCell, withStyles } from '@material-ui/core';
import React from 'react';

import styles from './styles';

const CondenseTableCell = props => <TableCell padding="none" {...props} />;

export default withStyles(styles)(CondenseTableCell);
